<template>
  <!-- El panel del resultado. Recibe una `vista` ya montada —tiempos, precios con su desglose,
       minutos línea a línea y visita fallida— y no hace ninguna cuenta: los importes los decide el
       cálculo de la herramienta, y un panel que recalculara algo podría enseñar otra cifra. -->
  <div class="res" aria-live="polite">
    <div class="res-h">
      <div><div class="k">Resultado</div><div class="t">{{ titulo }}</div></div>
      <span v-if="fuente" class="pill">{{ fuente }}</span>
    </div>
    <div class="times">
      <div><small>TPC</small><b>{{ v.tpc }}</b></div>
      <div><small>TPI</small><b>{{ v.tpi }}</b></div>
      <div><small>Desp.</small><b>{{ v.td }}</b></div>
      <div class="tot"><small>Total</small><b>{{ v.total }}</b></div>
    </div>
    <div class="price">
      <div class="k"><span>1ª inspección</span><span>{{ v.horas }}</span></div>
      <div class="big">{{ fmtEur(v.p1.total) }}</div>
      <div class="dl" v-for="(l, i) in v.p1.lineas" :key="'d1' + i"><span>{{ l.k }}</span><span>{{ fmtEur(l.v) }}</span></div>
      <div class="dl tot"><span>Total</span><span>{{ fmtEur(v.p1.total) }}</span></div>
    </div>
    <div v-if="v.p2" class="price second">
      <div class="k"><span>2ª inspección</span><span>{{ v.p2.pct }}</span></div>
      <div class="big">{{ fmtEur(v.p2.total) }}</div>
      <div class="dl" v-for="(l, i) in v.p2.lineas" :key="'d2' + i"><span>{{ l.k }}</span><span>{{ fmtEur(l.v) }}</span></div>
      <div class="dl tot"><span>Total</span><span>{{ fmtEur(v.p2.total) }}</span></div>
    </div>
    <details v-if="v.minutos && v.minutos.length" class="why" open>
      <summary>De dónde salen los minutos</summary>
      <div style="margin-top:6px">
        <div class="dl" v-for="(l, i) in v.minutos" :key="'m' + i"><span>{{ l.k }}</span><span>{{ l.v }} min</span></div>
        <div class="dl tot"><span>Total 1ª</span><span>{{ v.total }} min</span></div>
      </div>
    </details>
    <div v-if="v.fallida" class="fail">
      <div class="fail-h"><span>Visita fallida</span><b>{{ fmtEur(v.fallida.total) }}</b></div>
      <div class="dl" v-for="(l, i) in v.fallida.lineas" :key="'f' + i"><span>{{ l.k }}</span><span>{{ fmtEur(l.v) }}</span></div>
      <small>{{ v.fallida.nota }}</small>
    </div>
    <div class="res-f">
      <button type="button" @click="$emit('pdf')">Ver PDF</button>
      <button v-if="puedeGuardar" type="button" class="go" :disabled="!guardarListo" @click="$emit('guardar')">Guardar en línea</button>
    </div>
    <p v-if="puedeGuardar && !guardarListo && motivoGuardar" class="res-why">{{ motivoGuardar }}</p>
  </div>
</template>

<script>
export default {
  props: {
    titulo: { type: String, default: '' },
    fuente: { type: String, default: '' },
    /**
     * `{ tpc, tpi, td, total, horas, p1: {total, lineas:[{k,v}]}, p2: {total, pct, lineas} | null,
     *    minutos: [{k, v}], fallida: {total, lineas:[{k,v}], nota} | null }`
     */
    vista: { type: Object, required: true },
    puedeGuardar: { type: Boolean, default: false },
    guardarListo: { type: Boolean, default: true },
    motivoGuardar: { type: String, default: '' }
  },
  computed: {
    v: function () { return this.vista; }
  },
  methods: {
    fmtEur: function (n) {
      return (Math.round((n || 0) * 100) / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
  }
};
</script>

<style scoped>
.res{background:var(--result);color:var(--result-fg);border-radius:12px;overflow:hidden}
.res-h{padding:14px 18px;border-bottom:1px solid var(--result-line);display:flex;justify-content:space-between;gap:10px;align-items:flex-start}
.res-h .k{font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--result-muted)}
.res-h .t{font-family:var(--f-display);font-weight:600;font-size:15px}
.pill{font-size:10.5px;font-weight:700;padding:3px 8px;border-radius:999px;background:rgba(255,255,255,.12);white-space:nowrap}
.times{display:grid;grid-template-columns:repeat(4,1fr);gap:1px;background:var(--result-line);border-bottom:1px solid var(--result-line)}
.times div{background:var(--result);padding:10px 6px;text-align:center}
.times small{display:block;font-size:10px;letter-spacing:.08em;color:var(--result-muted);text-transform:uppercase}
.times b{font-family:var(--f-mono);font-size:19px;font-weight:600}
.times .tot b{color:#9BD07A}
.price{padding:14px 18px;border-bottom:1px solid var(--result-line)}
.price .k{font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:var(--result-muted);display:flex;justify-content:space-between}
.price .big{font-family:var(--f-display);font-size:34px;font-weight:700;letter-spacing:-.01em;margin:2px 0 8px}
.price.second .big{font-size:24px;color:#BFE0AA}
.dl{display:flex;justify-content:space-between;gap:10px;font-size:12.5px;padding:3px 0;color:#D6E1EC}
.dl span:last-child{font-family:var(--f-mono);font-variant-numeric:tabular-nums;white-space:nowrap}
.dl.tot{border-top:1px solid var(--result-line);margin-top:4px;padding-top:6px;color:#fff;font-weight:700}
.why{padding:12px 18px;border-bottom:1px solid var(--result-line)}
.why summary{cursor:pointer;font-size:12px;font-weight:700;color:var(--result-muted);letter-spacing:.06em;text-transform:uppercase}
.why .dl{font-size:12px}
.fail{padding:12px 18px;font-size:12px;color:#D6E1EC;border-bottom:1px solid var(--result-line)}
.fail-h{display:flex;justify-content:space-between;gap:10px;margin-bottom:4px}
.fail-h b{font-family:var(--f-mono);color:#fff}
.fail .dl{font-size:12px}
.fail small{display:block;color:var(--result-muted);font-size:11px;margin-top:4px}
.res-f{display:flex;gap:8px;padding:12px 18px 16px;flex-wrap:wrap}
.res-f button{flex:1;border-radius:8px;padding:9px 10px;font-weight:700;font-size:13px;cursor:pointer;border:1px solid rgba(255,255,255,.25);background:transparent;color:#fff;min-width:120px}
.res-f button.go{background:var(--leaf);border-color:var(--leaf)}
.res-f button:disabled{opacity:.55;cursor:not-allowed}
.res-why{margin:0;padding:0 18px 14px;font-size:11.5px;color:var(--result-muted)}
</style>
